import request from "./request";

//投放信息记录
export const getPros = (data) => request("/pro/getPros", data, "POST_JSON");
export const getPrincipalName = () => request("/productLog/getPrincipalName", null, "GET");
export const getTotalReportParams = () => request("/totalReport/getTotalReportParams", null, "GET");
export const getProductLog = (data) => request("/productLog/getProductLog", data, "GET");
export const addProductLog = (data) => request("/productLog/addProductLog", data, "POST");
export const modProductLog = (data) => request("/productLog/modProductLog", data, "POST");
export const delProductLog = (data) => request("/productLog/delProductLog", data, "POST");
export const changeRanking = (data) => request("/productLog/changeRanking", data, "POST");
export const modCompetitiveProduct = (data) => request("/productLog/modCompetitiveProduct", data, "POST");
// 获取表格表头
export const getColumn = () => request("/productLog/getColumn", null, "GET");
// 编辑表格表头
export const addColumn = (data) => request("/productLog/addColumn", data, "POST");

//渠道相关
export const getChnl = () => request("/productLog/getChnl", null, "GET");
export const addChnl = (data) => request("/productLog/addChnl", data, "POST_JSON");
export const modifyChnl = (data) => request("/productLog/modifyChnl", data, "POST_JSON");
export const deleteChnl = (data) => request("/productLog/deleteChnl", data, "POST");
